"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var PushNotification = (function () {
    function PushNotification() {
    }
    PushNotification.isPushNotificationSupported = function () {
        return Boolean(navigator['serviceWorker'] && window['PushManager'] && window['Notification']);
    };
    PushNotification.isPushNotificationPermitted = function () {
        return Boolean(this.isPushNotificationSupported() && Notification.permission === 'granted');
    };
    PushNotification.requestPushNotificationPermission = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, Notification.requestPermission()];
            });
        });
    };
    PushNotification.subscribe = function (applicationServerKey) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var serviceWorker, subscribeOptions;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, navigator.serviceWorker.ready];
                    case 1:
                        serviceWorker = _a.sent();
                        subscribeOptions = {
                            userVisibleOnly: true,
                            applicationServerKey: applicationServerKey
                        };
                        return [2, serviceWorker.pushManager.subscribe(subscribeOptions)];
                }
            });
        });
    };
    PushNotification.getSubscription = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var serviceWorker;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, navigator.serviceWorker.ready];
                    case 1:
                        serviceWorker = _a.sent();
                        return [2, serviceWorker.pushManager.getSubscription()];
                }
            });
        });
    };
    PushNotification.unsubscribe = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var subscription;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, PushNotification.getSubscription()];
                    case 1:
                        subscription = _a.sent();
                        if ((0, lodash_1.isNull)(subscription)) {
                            return [2, true];
                        }
                        return [2, subscription.unsubscribe()];
                }
            });
        });
    };
    return PushNotification;
}());
exports.default = PushNotification;
//# sourceMappingURL=push-notification.js.map